import axios, { endpoints } from 'src/utils/axios';
import handleOKRequest from 'src/components/grids/generic-grid/handleOKRequest';
import handleBadRequest from 'src/components/grids/generic-grid/handleBadRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';

//Modificar de acuerdo a la lógica de la acción
export const marcarPagadaComprasF = createAsyncThunk(
  'comprasForm/marcarPagadaComprasF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarPagadaComprasF,
        data
      );
      handleOKRequest(response, 'Compra maracada como pagada.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al marcar la compra como pagada.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarRecepcionadaComprasF = createAsyncThunk(
  'comprasForm/marcarRecepcionadaComprasF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarRecepcionadaComprasF,
        data
      );
      handleOKRequest(response, 'Compra marcada como recepcionada.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al marcar la compra como recepcionada.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const marcarCotizacionRecibidaComprasF = createAsyncThunk(
  'comprasForm/marcarCotizacionRecibidaComprasF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.marcarCotizacionRecibidaComprasF,
        data
      );
      handleOKRequest(
        response,
        'Se pasó la compra a estado: Cotización recibida.'
      );
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data ||
          'Error al marcar la compra en estado: Cotización recibida.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const solicitarCotizacionComprasF = createAsyncThunk(
  'comprasForm/solicitarCotizacionComprasF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.actions.solicitarCotizacionComprasF,
        data
      );
      handleOKRequest(response, 'Acción ejecutada correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al ejecutar la acción.'
      );
    }
  }
);

//Modificar de acuerdo a la lógica de la acción
export const realizarPedidoComprasF = createAsyncThunk(
  'comprasForm/realizarPedidoComprasF',
  async ({ data }: { data: any }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        endpoints.actions.realizarPedidoComprasF,
        data
      );
      handleOKRequest(response, 'Pedido realizado correctamente.');
      return response.data;
    } catch (error) {
      handleBadRequest(error);
      return rejectWithValue(
        error.response?.data || 'Error al realizar el pedido.'
      );
    }
  }
);
